import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {FileuploadComponent} from './file-upload.component'

const routes: Routes = [
    {
        path: '',
        data: { title: 'Fileupload' },
        children: []
    },
    {
        path: 'home',
        component: FileuploadComponent,
       
    }
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FileuploadRoutingModule { }
